import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

// Reusable dark hero for inner pages with breadcrumb + parallaxable image.
export default function PageHero({ overline, title, subtitle, image, crumbs = [] }) {
  return (
    <section data-testid="page-hero" className="relative bg-gema-black pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden">
      {image && (
        <>
          <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25 grayscale" />
          <div className="absolute inset-0 bg-gradient-to-t from-gema-black via-gema-black/70 to-gema-black/40" />
        </>
      )}
      <div className="container-gema relative z-10">
        <nav className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-white/40 mb-8" aria-label="Ruta">
          <Link to="/" className="hover:text-gema-red transition-colors">Inicio</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight className="h-3 w-3" />
              {c.to ? <Link to={c.to} className="hover:text-gema-red transition-colors">{c.label}</Link> : <span className="text-white/70">{c.label}</span>}
            </span>
          ))}
        </nav>
        {overline && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="overline mb-4">{overline}</motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="heading-xl text-white max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 text-white/60 text-base md:text-lg max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
